// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".per-page-selector[data-v-701130b8] {width:-webkit-fit-content!important;width:-moz-fit-content!important;width:fit-content!important}.per-page-selector[data-v-701130b8]  button{padding:4px 16px;margin-bottom:4px}.two-line-ellipsis[data-v-701130b8]{overflow:hidden;max-width:240px;min-width:120px;display:-webkit-box;line-clamp:2;-webkit-line-clamp:2;-webkit-box-orient:vertical}", ""]);
// Exports
module.exports = exports;
